import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export const FreightRateChart = ({ data, theme }) => {
  // Transform data for chart
  const chartData = React.useMemo(() => {
    if (!data || data.length === 0) return [];
    
    // Group by lane
    const byLane = {};
    data.forEach(item => {
      if (!byLane[item.lane]) {
        byLane[item.lane] = {
          lane: item.lane,
          avgRate: 0,
          count: 0
        };
      }
      byLane[item.lane].avgRate += item.rate_usd_per_mt;
      byLane[item.lane].count += 1;
    });
    
    return Object.values(byLane).map(item => ({
      lane: item.lane,
      rate: Math.round(item.avgRate / item.count)
    }));
  }, [data]);

  if (chartData.length === 0) {
    return (
      <Card data-testid="freight-rate-chart">
        <CardHeader>
          <CardTitle>Freight Rates by Lane</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-64 flex items-center justify-center text-[hsl(var(--muted-foreground))]">
            No data available
          </div>
        </CardContent>
      </Card>
    );
  }

  const gridColor = theme === 'dark' ? 'hsl(215 16% 20%)' : 'hsl(213 18% 86%)';
  const textColor = theme === 'dark' ? 'hsl(0 0% 100%)' : 'hsl(216 20% 12%)';

  return (
    <Card data-testid="freight-rate-chart">
      <CardHeader>
        <CardTitle>Freight Rates by Lane (USD/MT)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
              <CartesianGrid stroke={gridColor} strokeDasharray="3 3" />
              <XAxis 
                dataKey="lane" 
                tick={{ fontSize: 12, fill: textColor }} 
                stroke={gridColor}
              />
              <YAxis 
                tick={{ fontSize: 12, fill: textColor }} 
                stroke={gridColor}
              />
              <Tooltip 
                wrapperStyle={{ borderRadius: 8 }} 
                contentStyle={{ 
                  backgroundColor: theme === 'dark' ? 'hsl(220 15% 8%)' : 'hsl(0 0% 100%)', 
                  border: `1px solid ${gridColor}`,
                  borderRadius: 8,
                  color: textColor
                }} 
              />
              <Bar 
                dataKey="rate" 
                fill="hsl(187 50% 42%)" 
                name="Avg Rate"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};